import { render } from "./ManuallyRecordPayment.vue?vue&type=template&id=657d7b4f&scoped=true"
import script from "./ManuallyRecordPayment.vue?vue&type=script&lang=js"
export * from "./ManuallyRecordPayment.vue?vue&type=script&lang=js"

import "./ManuallyRecordPayment.vue?vue&type=style&index=0&id=657d7b4f&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657d7b4f"]])

export default __exports__